import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'
     
const Relationship = lazy (() => import ('./Relationship.jsx')) 

const RelationshipRoutes = [
    {
        path: '/Relationship',
        component: Relationship,
        auth: authRoleAccess.manage_relationship,
    },
   
]

export default RelationshipRoutes 